import React from "react";
import { Modal } from "antd";

type Props = {
    loginModal: boolean;
    setLoginModal: (v: boolean) => void;
    handlegetWallet?: () => void;
};

const TopUpInfoModal: React.FC<Props> = ({ loginModal, setLoginModal }) => {
    return (
        <Modal
            open={loginModal}
            title="How to Top Up Your Wallet"
            onCancel={() => setLoginModal(!loginModal)}
            okText="Close"
            onOk={() => setLoginModal(false)}
            footer={undefined}
        >
            <div className="space-y-4">
                <p className="text-sm">
                    Contact administrator to top up your wallet.
                </p>
            </div>
        </Modal>
    );
};

export default TopUpInfoModal;
